(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bai-purchase-options"] && !Shopify.designMode) return;
  try {
    class BaiPurchaseOptions extends HTMLElement {
    connectedCallback() {
      this.planInput = this.querySelector('[data-selling-plan]');
      if (!this.planInput) return;
      this.addEventListener('change', (e) => {
        if (e.target.name === 'bai_purchase_type') this.update(e.target);
      });
    }

    get form() {
      return document.getElementById(this.dataset.formId);
    }

    /* Price under the title + in the mobile sticky bar (same section) */
    get priceContainers() {
      const section = this.closest('.shopify-section') || document;
      return section.querySelectorAll('product-price [ref="priceContainer"], .sticky-add-to-cart__price [ref="priceContainer"]');
    }

    showPrice(text) {
      this.priceContainers.forEach((el) => {
        if (el.dataset.baiOriginal === undefined) el.dataset.baiOriginal = el.innerHTML;
        if (text) {
          el.innerHTML = '';
          const span = document.createElement('span');
          span.className = 'price-item__group price';
          span.textContent = text;
          el.append(span);
        } else {
          el.innerHTML = el.dataset.baiOriginal;
        }
      });
    }

    update(radio) {
      const planId = radio.value;
      const sub = Boolean(planId);
      const form = this.form;
      const wrap = form?.closest('product-form-component') || form;
      const qty = form?.querySelector('input[name="quantity"]');
      this.planInput.value = planId;
      this.planInput.disabled = !sub;
      if (wrap) wrap.toggleAttribute('data-bai-subscription', sub);
      this.showPrice(sub ? radio.dataset.price : null);
      if (qty) {
        if (sub) {
          if (!qty.readOnly) this.previousQty = qty.value;   // keep the one-time quantity
          qty.value = radio.dataset.qty;
          qty.readOnly = true;
        } else {
          qty.readOnly = false;
          qty.value = this.previousQty || 1;
        }
        qty.dispatchEvent(new Event('change', { bubbles: true }));
        // Tell Horizon's sticky Add to bag bar too, so it reads "Add to bag (2)"
        const update = new Event('quantity-selector:update', { bubbles: true });
        update.detail = { quantity: Number(qty.value) };
        qty.dispatchEvent(update);
      }
    }
  }
  if (!customElements.get('bai-purchase-options')) customElements.define('bai-purchase-options', BaiPurchaseOptions);
  } catch(e) { console.error(e); }
})();

})();
